
import { SearchFilters } from '../../../maps-search/schemas'
import { Component, Prop } from 'vue-property-decorator'
import { SeenCampsites } from '../../SeenCampsites'
import { PuMapProps } from '../pu-map/PuMapProps'
import { Marker, MarkerType } from '../pu-map/types'
import CampsitesMapBase from './CampsitesMapBase'
import { ResultCampsitesMapProps, ResultMapCampsite } from './CampsitesMapProps'

@Component
export default class CampsiteResultsMap
  extends CampsitesMapBase
  implements ResultCampsitesMapProps
{
  @Prop({ required: true })
    campsites: ResultMapCampsite[]

  @Prop({ required: true })
    searchFilters: SearchFilters

  private seenCampsites: string[] = []
  private seenCampsitesService: SeenCampsites

  mounted() {
    this.seenCampsitesService = new SeenCampsites(this.searchFilters)
    this.seenCampsites = this.seenCampsitesService.get()
  }

  get puMapProps(): PuMapProps {
    return {
      initialZoom: this.initialZoom,
      markers: this.markers,
      initialBounds: this.initialBounds,
      circle: this.circle,
      visibleMarker: this.visibleMarker,
      centre: this.centre,
      useClustering: this.useClustering,
      showGeolocationIcon: true,
      zoomControl: !!this.$isDesktop,
      scrollWheelZoom: true,
    }
  }

  // TODO: If we manage to check isFavourite in MapsMain then we can avoid this loop and pass it from the parent
  // considering looping over 1k+ objects this can be a good optimisation?
  private get markers(): Marker[] {
    return this.campsites.map(({ slug, name, point, price, id }) => {
      return {
        campsiteId: id,
        name,
        position: point,
        price,
        seenMarkers: this.seenCampsites,
        slug,
        type: price ? MarkerType.price : MarkerType.icon,
      }
    })
  }

  async onMarkerSelected(slug: string) {
    this.$emit('marker-selected', slug)
    await this.seenCampsitesService.add(slug)
    // Re-set it explicitly because Set.add is not reactive (at least in Vue2)
    this.seenCampsites.splice(
      0,
      this.seenCampsites.length,
      ...this.seenCampsitesService.get(),
    )
  }
}
